// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WWJHlry4UY0YsRTem25l{height:100%}.whRBjsYCYA4JImeJOMAX{justify-content:center;align-items:center;height:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `WWJHlry4UY0YsRTem25l`,
	"loader": `whRBjsYCYA4JImeJOMAX`
};
export default ___CSS_LOADER_EXPORT___;
